import { BaseFormat } from "./baseFormat";

export class Fotos3x4Format extends BaseFormat {
  constructor(options = {}) {
    super(options);
    this.previewScale = options.previewScale ?? 0.5;
  }

  get tipo() {
    return "fotos_3x4";
  }

  get canvasSize() {
    // 3cm × 4cm a 300 DPI = 354 × 472px por foto
    // Grade 4×2 em folha paisagem (1774×1182). Canvas = slot × 2 × previewScale
    // A 0,5: canvas 354×472 | export (scaleFinal=2) = 708×944 → escala 0,5 no slot
    const slotW = Math.round((3 * 300) / 2.54); // 354px
    const slotH = Math.round((4 * 300) / 2.54); // 472px
    return {
      width: slotW * 2 * this.previewScale,
      height: slotH * 2 * this.previewScale,
    };
  }

  get scaleFinal() {
    return 1 / this.previewScale;
  }

  // Foto de documento: sem moldura. O editor nem oferece o menu Molduras.
  get supportsMolduras() {
    return false;
  }

  // 3x4 é sempre retrato: a folha de impressão é montada com slots 3cm × 4cm,
  // então o editor não oferece o botão Retrato/Paisagem.
  get supportsOrientation() {
    return false;
  }

  filterMolduras(listaMolduras, orientationId) {
    return listaMolduras.filter(
      (m) => m.dados.tipo === this.tipo && m.dados.orientacao === orientationId
    );
  }
}
